import styled from "styled-components";
import { respondTo, breakpoints } from "../../styles";

export const AccountPanelSectionWrapper = styled.div`
  padding: 0 75px 0;
  width: calc(100% + 150px);
  left: -75px;
  position: relative;
  counter-reset: ${(props) =>
    props.counterName || "none"}; // for counter component in lists
`;

export const AccountPanelSectionCurvedBottom = styled.div`
  background-color: ${(props) =>
    props.odd ? "var(--pmbJungleMist)" : "var(--pmbMystic)"};
  position: relative;
  width: calc(100% + 300px);
  left: -150px;
  border-radius: 0 0 78% 78% / 175px;
  padding-bottom: ${(props) => props.paddingBottom || "20px"};
`;

export const AccountPanelSection = styled.section`
  background-color: ${(props) => props.bgColor || "var(--pmbJungleMist)"};
  position: relative;
  padding: 0px 150px 50px;
  width: calc(100% + 300px);
  left: -150px;
  z-index: 4;

  &:nth-of-type(even) {
    background-color: ${(props) => props.bgColor || "var(--pmbMystic)"};
  }

  &:last-child {
    padding: 0px 150px 0;

    ${AccountPanelSectionCurvedBottom} {
      border-radius: unset;
      padding-bottom: 90px;
    }
  }
`;

export const AccountPanelArticle = styled.article`
  max-width: ${breakpoints.lg};
  margin: 0 auto;
  position: relative;

  ${respondTo.xl`
    max-width: ${breakpoints.xl};
  `}
`;

export const AccountPanelTopHeader = styled.header`
  background-color: var(--pmbMystic);
  position: relative;
  width: calc(100% + 300px);
  left: -150px;
  z-index: 5;
  padding-bottom: 50px;

  ${AccountPanelSectionCurvedBottom} {
    background-color: var(--accountBg);
    padding: 0 0 60px;
  }
`;
